import PolicyExclusions from "./policyExclusions"

export default PolicyExclusions
